import { commonSlice, store } from "../../store";
import { DriversRow } from "../../api";
import { reserveShiftsSlice } from "../../features/Reserve/store";

export const filterOffice = async (officeId: number): Promise<void> => {
    store.dispatch(reserveShiftsSlice.actions.update_office_id(officeId));
};

export const filterDriver = async (
    driver: DriversRow | null
): Promise<void> => {
    if (driver) {
        store.dispatch(
            reserveShiftsSlice.actions.update_driver_ids([driver.driverId!])
        );
        store.dispatch(commonSlice.actions.updateSelectedDriver(driver));
    } else {
        store.dispatch(reserveShiftsSlice.actions.update_driver_ids([]));
        store.dispatch(commonSlice.actions.updateSelectedDriver(null));
    }
};

export const filterStartDate = async (startDate: string): Promise<void> => {
    store.dispatch(reserveShiftsSlice.actions.update_start_date(startDate));
};

export const filterEndDate = async (endDate: string): Promise<void> => {
    store.dispatch(reserveShiftsSlice.actions.update_end_date(endDate));
};

export const filterNeedGuidance = async (selector: boolean): Promise<void> => {
    store.dispatch(
        reserveShiftsSlice.actions.update_need_guidance_only(selector)
    );
};
